import React, { useState, useEffect, Dispatch } from 'react';
import { CancelTokenSource } from 'axios';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { myProfileService } from '@app/services';
import { MethodsMfa } from '@app/enums';
import { SetStepManageMfa } from '@app/models';
import { getComponentUI, getConfigureComponentUI } from '../helpers';
import { pushSetUpManageMfa, handleClickSecondaryManageMfa } from '@app/helpers';

interface IProps {
    setErrorMessage: Dispatch<string>;
    sourceCancel: CancelTokenSource;
    setIsDisableButtonNext: Dispatch<boolean>;
    isDisableButtonNext: boolean;
    activeMethod: string;
    setStepManageMfa: SetStepManageMfa;
    setPassCode: Dispatch<string>;
    passCode: string;
    errorMessage: string;
    setCompleted?: () => void;
}

export const SetUpDevice: React.SFC<IProps> = ({
    setErrorMessage,
    setIsDisableButtonNext,
    isDisableButtonNext,
    setStepManageMfa,
    activeMethod,
    sourceCancel,
    setPassCode,
    passCode,
    errorMessage,
    setCompleted
}) => {
    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();

    const [tokenSecret, setTokenSecret] = useState<string>('');
    const [isTokenSecretLoading, setIsTokenSecretLoading] = useState<boolean>(false);
    const [isTokenSecretError, setIsTokenSecretError] = useState<boolean>(false);
    const [encodedKey, setEncodedKey] = useState<string>('');
    const [registrationId, setRegistrationId] = useState<string>('');
    const [isUserPushActivated, setIsUserPushActivated] = useState<boolean>(false);
    const [retryCounterSetUpPush, setRetryCounterSetUpPush] = useState<number>(1);

    const [isNeedExpandToken, setIsNeedExpandToken] = useState<boolean>(true);
    const [isNeedExpandTokenBlock, setIsNeedExpandTokenBlock] = useState<boolean>(true);
    const getMfaCredentials = () => {
        setIsTokenSecretLoading(true);
        setIsTokenSecretError(false);
        myProfileService.getMfaCredentialsForInstall().then(({ data }) => {
            setTokenSecret(data.tokenSecret);
            setEncodedKey(data.encodedKey);
            setRegistrationId(data.registrationId);
            setIsTokenSecretLoading(false);
            setIsTokenSecretError(false);
        }).catch(() => {
            setIsTokenSecretLoading(false);
            setIsTokenSecretError(true);
        });
    };

    useEffect(() => {
        if (activeMethod !== MethodsMfa.u2f) {
            getMfaCredentials();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (
            (activeMethod === MethodsMfa.iPhone ||
                activeMethod === MethodsMfa.android) &&
            isDisableButtonNext
        ) {
            const timeoutId = setTimeout(() => {
                setIsDisableButtonNext(false);
            }, 30 * 1000);

            return () => {
                clearTimeout(timeoutId);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (
            registrationId &&
            (activeMethod === MethodsMfa.iPhone || activeMethod === MethodsMfa.android)
        ) {
            pushSetUpManageMfa(
                registrationId,
                sourceCancel,
                setIsUserPushActivated,
                setStepManageMfa,
                () => {
                    setIsUserPushActivated(false);
                    setErrorMessage(translation('MFA_PUSH_VERIFY_BLOCKED'));
                },
              setCompleted
            ).catch(() => {
                if (retryCounterSetUpPush < 20) {
                    setRetryCounterSetUpPush(retryCounterSetUpPush + 1);
                } else {
                    handleClickSecondaryManageMfa(sourceCancel, setStepManageMfa, dispatch)();
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [registrationId, retryCounterSetUpPush, activeMethod]);

    return (
        <>
            {activeMethod !== MethodsMfa.u2f && (<h1>{translation('SETUP_2FA_TITLE')}</h1>)}
            {getComponentUI(activeMethod)}
            {getConfigureComponentUI({
                activeMethod,
                isUserPushActivated,
                tokenSecret,
                encodedKey,
                setIsNeedExpandToken,
                setStepManageMfa,
                isNeedExpandTokenBlock,
                setIsNeedExpandTokenBlock,
                setIsDisableButtonNext,
                isNeedExpandToken,
                setPassCode,
                passCode,
                errorMessage,
                setErrorMessage,
                getMfaCredentials,
                isTokenSecretLoading,
                isTokenSecretError,
                setCompleted
            })}
        </>
    );
};
